import { FormattedMessage } from 'localization';

import { EnumChatSettingRoutes, EnumDeskRoutes } from '../../../constants';

const chatSection = [
  {
    value: `/${EnumDeskRoutes.settings}/${EnumChatSettingRoutes.chatStyle}`,
    label: (
      <div className="capitalize">
        <FormattedMessage id="chat.chat-style" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumChatSettingRoutes.chatContent}`,
    label: (
      <div className="capitalize">
        <FormattedMessage id="chat.content" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumChatSettingRoutes.chatInstallation}`,
    label: (
      <div className="capitalize">
        <FormattedMessage id="chat.installation" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumChatSettingRoutes.chatAvailability}`,
    label: (
      <div className="capitalize">
        <FormattedMessage id="chat.availability" />
      </div>
    ),
  },
  {
    value: `/${EnumDeskRoutes.settings}/${EnumChatSettingRoutes.automation}`,
    label: (
      <div className="capitalize">
        <FormattedMessage id="chat.automations" />
      </div>
    ),
  },
];

export { chatSection };
